<template>
    <div>
        <a-card title="应用配置">
            <div class="fixedBtnBox">
                <a-button type="primary" @click="updateSelected" style="margin-right:20px;">更新选中</a-button>
                <a-button type="primary" @click="updateAll" style="margin-right:20px;">更新所有</a-button>
                <a-button icon="history" type="primary" slot="extra" @click="handleConfigHistory" style="margin-right:20px;">修改历史</a-button>
                <a-button slot="extra" type="primary" @click="handleNewFile">新增</a-button>
                <a-button style="margin-left:20px;" v-if="G.isUserAdmin()" slot="extra" type="primary" @click="configGlobal">全局配置</a-button>
            </div>
            <!-- <envitems v-on:envchanged="envChanged"></envitems> -->
            <!-- <sysitems v-on:syschanged="sysChanged"></sysitems> -->
            <a-form layout="inline" style="margin-bottom:20px;" @keyup.enter.native="handleSubmit">
                <a-form-model-item label="版本">
                    <a-select v-model="searchP.version" placeholder="" style="width: 80px">
                        <a-select-option value=""> 全部 </a-select-option>
                        <a-select-option value="V3.0"> 3.0 </a-select-option>
                        <a-select-option value="V5.0"> 5.0 </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-item label="系统编码">
                    <SysAutoComplete ref="syscodeAss" @onSysCodeChange="handleSearchSyscodeChange"></SysAutoComplete>
                </a-form-item>
                <a-form-item label="应用编码">
                    <AppAutoComplete ref="appcodeAss" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                </a-form-item>
                <a-form-model-item label="配置项">
                    <a-input placeholder="请输入配置项关键字" v-model="searchP.configitem"></a-input>
                </a-form-model-item>

                <a-form-item>
                    <a-button type="primary" @click="handleSubmit">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" @click="handleSearchReset">重置</a-button>
                </a-form-item>
            </a-form>

            <!-- 系统列表 -->
            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:'checkbox'}" :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id">
                <template slot="operation" slot-scope="text, record">
                    <div class="editable-row-operations">
                        <span>
                            <router-link :to="{
                        path:'edit',
                        query: {
                            id: record.id
                        }
                    }">编辑</router-link>
                        </span>
                        <span>
                            <a-popconfirm title="确认删除?" @confirm="() => onFileDelete(record)">
                                <a>删除</a>
                            </a-popconfirm>
                        </span>

                        <span>
                            <router-link :to="{
                        path:'configlog',
                        query: {
                            appcode: record.appcode,
                            configitem: record.configitem
                        }
                    }">修改历史</router-link>
                        </span>
                    </div>
                </template>
                <template slot="appcodet" slot-scope="text, record">
                    <span>
                        <router-link :to="{
                path:'/system/editapp',
                query: {
                    appcode: record.appcode,
                }
            }">{{text}}</router-link>
                    </span>
                </template>
                <template slot="syscodet" slot-scope="text, record">
                    <span>
                        <router-link :to="{
                path:'/system/edit',
                query: {
                    syscode: record.syscode,
                }
            }">{{text}}</router-link>
                    </span>
                </template>
            </a-table>

            <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
        </a-card>
    </div>
</template>

<script>
import AppAutoComplete from '@/components/AppAutoComplete'
import SysAutoComplete from '@/components/SysCodeAutoComplete'

const columns = [
    {
        title: '序号',
        width: 50,
        align: 'center',
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP
            return (Number(page) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
        width: 120,
        scopedSlots: { customRender: 'version' },
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        width: 120,
        scopedSlots: { customRender: 'syscode' },
    },
    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
        scopedSlots: { customRender: 'appcodet' },
    },
    {
        title: '配置项',
        dataIndex: 'configitem',
        align: 'center',
        scopedSlots: { customRender: 'configitem' },
    },
    {
        title: '配置项参数',
        dataIndex: 'configvalue',
        align: 'center',
        ellipsis: true,
        scopedSlots: { customRender: 'configvalue' },
    },
    {
        title: '备注',
        dataIndex: 'remark',
        align: 'center',
        ellipsis: true,
        scopedSlots: { customRender: 'remark' },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    },
]

let searchP = {
    currentAppCode: '',
    syscode: '',
    version: '',
    configitem: '',
    total: 0,
    pageSize: 10,
    page: undefined,
}

const data = []
export default {
    data() {
        return {
            selectedRowKeys: [],
            form: this.$form.createForm(this),
            data,
            columns,
            searchP: searchP,
            tLoading: true,
            spingFlag: false,
            spingText: '',
            spingCurrent: 0,
            spingFailed: 0,
            spingTotal: 0,
        }
    },
    methods: {
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },

        updateSelected() {
            this.spingFlag = true
            this.spingCurrent = 0
            this.spingFailed = 0
            let that = this
            let targetList = that.data.filter((item) => {
                return that.selectedRowKeys.indexOf(item.id) != -1
            })
            that.updateList(targetList)
        },
        updateAll() {
            this.spingFlag = true
            this.spingCurrent = 0
            this.spingFailed = 0
            this.getAllFileList()
        },
        getAllFileList() {
            let c_params = {
                configtype: '01',
                page: 1,
                pageSize: this.searchP.total,
                currentAppCode: this.searchP.currentAppCode,
                syscode: this.searchP.syscode,
            }
            this.$store
                .dispatch({
                    type: 'configcenter/selectFile',
                    params: c_params,
                })
                .then((res) => {
                    this.tLoading = false
                    if (res.status == '200') {
                        let result = res.data.data.list
                        this.updateList(result)
                    } else {
                        this.spingFlag = false
                    }
                })
        },
        updateList(recordList) {
            if (recordList.length < 0) {
                return
            }
            this.spingTotal = recordList.length
            this.spingCurrent = 1
            this.spingFailed = 0
            this.updateOneItem(recordList, 0)
        },

        updateOneItem(recordList, index) {
            let that = this

            that.$store
                .dispatch({
                    type: 'configcenter/editFile',
                    params: { ...recordList[index] },
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        that.spingCurrent += 1
                    } else {
                        that.spingFailed += 1
                    }
                    that.updateText()
                    if (index < this.spingTotal - 1) {
                        index++
                        that.updateOneItem(recordList, index)
                    } else {
                        that.spingFlag = false
                    }
                })
        },
        updateText() {
            this.spingText =
                '正在更新 ' +
                this.spingCurrent +
                '/' +
                this.spingTotal +
                '  失败 ' +
                this.spingFailed
        },
        handleSearchAppcodeChange(value) {
            this.searchP.currentAppCode = value
        },
        handleSearchSyscodeChange(value) {
            this.searchP.syscode = value
        },
        handleSearchReset() {
            this.searchP.page = 1
            this.searchP.currentAppCode = ''
            this.searchP.syscode = ''
            this.searchP.version = ''
            this.updateRoute()
        },
        handleSubmit() {
            this.searchP.page = 1
            this.updateRoute()
        },
        getFileList() {
            let c_params = {
                configtype: '01',
            }
            //;(this.tLoading = true),
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'configcenter/selectFile',
                    params: c_params,
                })
                .then((res) => {
                    this.tLoading = false
                    let result = res.data.data
                    this.data = result.list
                    this.searchP.total = result.totalRecords
                    this.searchP.pageSize = result.pageSize
                    this.searchP.page = result.page
                })
        },
        // 分页事件
        handlePageChange(c) {
            this.searchP.page = c
            this.updateRoute()
        },
        updateRoute() {
            this.$router.push({
                query: {
                    currentAppCode: this.searchP.currentAppCode,
                    syscode: this.searchP.syscode,
                    page: this.searchP.page,
                    version: this.searchP.version,
                    configitem: this.searchP.configitem,
                },
            })
        },
        handleNewFile() {
            this.$router.push({
                path: 'edit',
                query: {
                    id: '',
                },
            })
        },
        configGlobal() {
            this.$router.push({
                path: 'configGlobal',
                query: {},
            })
        },
        onFileDelete(key) {
            this.$store
                .dispatch({
                    type: 'configcenter/deleteFile',
                    params: { ...key },
                })
                .then((res) => {
                    if (res.status == '200') {
                        this.getFileList()
                    }
                })
        },
        handleConfigHistory() {
            this.$router.push({
                path: '/configcenter/configlog',
                query: {},
            })
        },
    },
    computed: {},
    components: {
        AppAutoComplete,
        SysAutoComplete,
    },
    watch: {
        $route() {
            this.$router.go(0)
        },
    },
    mounted() {
        let query = this.$route.query
        this.searchP.currentAppCode = query.currentAppCode
            ? query.currentAppCode
            : ''
        this.searchP.syscode = query.syscode ? query.syscode : ''
        this.searchP.configitem = query.configitem ? query.configitem : ''
        this.searchP.page = query.page ? +query.page : 1
        this.searchP.version = query.version ? query.version : ''
        this.$refs.appcodeAss.setInputVal(this.searchP.currentAppCode)
        this.$refs.syscodeAss.setInputVal(this.searchP.syscode)

        this.getFileList()
    },
    created() {},
}
</script>

<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}
td {
    padding: 10px 10px;
}
.fixedBtnBox {
    position: absolute;
    top: 10px;
    right: 20px;
}
</style>
